import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { useRealtimeEvents } from "@/hooks/useRealtimeEvents";
import { useDraggable } from "@/hooks/useDraggable";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Floating "tu horóscopo" button. Shown only when the user has active horoscope access.
 * Hidden on /lecturaonline and /admin and auth pages.
 */
export const HoroscopeFloat = () => {
  const { user, authHeader } = useAuth();
  const location = useLocation();
  const [access, setAccess] = useState(null);
  const drag = useDraggable();

  const refresh = async () => {
    if (!user || user.role === "admin") { setAccess(null); return; }
    try {
      const r = await axios.get(`${API}/users/horoscope/access`, { headers: authHeader() });
      setAccess(r.data);
    } catch { setAccess(null); }
  };

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [user]);

  useRealtimeEvents({
    notification: () => refresh(),
  });

  if (!user || user.role === "admin") return null;
  if (!access?.has_access) return null;
  const path = location.pathname;
  if (path.startsWith("/lecturaonline") || path.startsWith("/admin") || path.startsWith("/horoscopo")) return null;
  if (path.startsWith("/ingresar") || path.startsWith("/registro") || path.startsWith("/login")) return null;

  return (
    <Link
      to="/horoscopo"
      data-testid="horoscope-float-btn"
      ref={drag.ref}
      onPointerDown={drag.onPointerDown}
      onPointerMove={drag.onPointerMove}
      onPointerUp={drag.onPointerUp}
      onPointerCancel={drag.onPointerCancel}
      data-draggable="true"
      className="fixed left-6 bottom-[21rem] z-[70] flex items-center gap-2 px-4 py-2.5 rounded-full bg-gradient-to-r from-fuchsia-600 via-purple-600 to-indigo-600 text-white shadow-2xl shadow-purple-500/40 border-2 border-fuchsia-300/30 hover:scale-105 transition cursor-grab active:cursor-grabbing"
      style={{ ...drag.style, animation: "pulseGlow 2.5s ease-in-out infinite" }}
    >
      <span className="text-xl animate-pulse">🔮</span>
      <span className="text-xs font-bold uppercase tracking-widest">Tu Horóscopo</span>
      <style>{`
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 24px rgba(192, 38, 211, 0.4); }
          50% { box-shadow: 0 0 36px rgba(192, 38, 211, 0.8); }
        }
      `}</style>
    </Link>
  );
};
